import { create } from 'zustand'
import { immer } from "zustand/middleware/immer";

export const useAtendimentoSacStorage = create(immer(set => ({
    dados: {
        allData: [],
        sistemColor: {
            primary: '#FF7418',
            secondary: '#5E2572'
        },
        logo: null,
        grupoIncidente: 'AZAPERS',
    },
    loaders: {
        loadingStartAtendimento: true,
    },
    dispatch: {
        setSistemColor: (payload) => set(state => {
            state.dados.sistemColor = payload
        }),
        setLogo: (payload) => set(state => {
            state.dados.logo = payload
        }),
        setAllData: (payload) => set(state => {
            state.dados.allData = payload
        }),
        setGrupoIncidente: (payload) => set(state => {
            state.dados.grupoIncidente = payload
        }),
        setLoadingStartAtendimento: (payload) => set(state => {
            state.loaders.loadingStartAtendimento = payload
        }), 
    }
})))
